import { useEffect, useState, useRef } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import TabExtraContent from '../common/TabExtraContent'
import UMCButton from '../common/UMCButton'
import { getHTMLObject, getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Select, Button } from 'antd'
import { DARK_GRAY, PURPLE, } from "../../styles/styleUtils"
import getData from './GetData'
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import InputField from "./InputField"
import NameNumberListComponent from "./NameNumberListComponent"
import CustomDialog from './CustomDialog'
import { produce } from 'immer';
import parse from 'html-react-parser'

//========================================
// Dispatch Console second config page
//========================================
const RSIConfig = ({ onPrevious, onNext, activeProfile, trunkConfig, setTrunkConfig, configurationData, setConfigurationData }) => {
    const [errorsOnPage, setErrorsOnPage] = useState(0);

    const [workingSipTrunkConfig, setWorkingSipTrunkConfig] = useImmer({});

    // Name/Number array of child component. This is kept in a separate file to manage easily the item add/remove
    // and to be able to manage the create button
    const [nameNumber, setNameNumber] = useImmer((trunkConfig?.Profile?.UI_DispatchConsole_Prefix?.RSI_Prefix ?? [])); 

    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    const [footer, setFooter] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);
    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    let errorsOnRedraw = errorsOnPage;

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_TRUNK") + " : " + activeProfile.name));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        if (trunkConfig?.Profile !== undefined) {
            setWorkingSipTrunkConfig(trunkConfig);
        }
    }, []);

    useEffect(() => {
        errorHandler((nameNumber?.length > 0) ? false : true);
    }, [nameNumber]);

    const updatePrefixes = (value) => {
        if (workingSipTrunkConfig?.Profile?.UI_DispatchConsole_Prefix?.RSI_Prefix)
            return produce(workingSipTrunkConfig, draft => { draft.Profile.UI_DispatchConsole_Prefix.RSI_Prefix = value; });
    };

    const updatePrefixesAndClean = (value) => {
        if (workingSipTrunkConfig?.Profile?.UI_DispatchConsole_Prefix?.RSI_Prefix)
            return produce(workingSipTrunkConfig, draft => {
                delete draft.Profile.UI_Prefix;
                delete draft.Profile.UI_DC_Ext_Gateway_Data;
                draft.Profile.UI_DispatchConsole_Prefix.RSI_Prefix = value;
            });
    };

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-DC_RSI-Config`, "_blank")
            }}
        />
    }

// Previous button handler. The previous page is the profile selection so we have to erase the trunk config
    const onPreviousPage = () => {
        let updatedConfig;

        // Update the prefixes array in the working buffer
        updatedConfig = updatePrefixes(nameNumber);

        // Update the parent state
        setTrunkConfig(updatedConfig);
        
        onPrevious();
    }

    // Validation handler for the page
    async function validateFields() {

    }

    const createProfile = async () => {
        let updatedConfig;     
        
        // Update prefixes array in the working buffer and erase the json structure of second page
        updatedConfig = updatePrefixesAndClean(nameNumber);

        // Update the parent state
        setTrunkConfig(updatedConfig);

        await validateFields();

        if (errorsOnRedraw === 0) {
            onNext(2);
        }
    }

    const switchToAdvanced = async () => {
        let updatedConfig;

        // Update the prefixes array in the working buffer
        updatedConfig = updatePrefixes(nameNumber);

        // Update the parent state
        setTrunkConfig(updatedConfig);

        await validateFields();

        // Ask if advanced (3rd page) has to be configured, if all is ok
        
        setDlgType("Info");
        setTitle(getTranslated(dict, "LABEL_DC_ADVANCED"));   
        setMessage(parse("<br/>" + getTranslated(dict, "MSG_DC_ADVANCED_CONTINUE") + "<br/>" + getTranslated(dict, "MSG_Q_CONTINUE")));
        setFooter(yesno);
        showModal(true);
        
        // onNext is called in the callback of yes button depending on the choice (handleAdvanced)
    }

    // Error handler (count errors on the page)
    const errorHandler = (value) => {

        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleAdvanced = () => {
        setIsModalOpen(false);

        if (errorsOnRedraw === 0) {
            onNext();
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Buttons for modal footer
    const yesno = [
        <Button key="cancel" type="primary" onClick={handleCancel} className="sip-modal-btn sip-navigation-back">
            {getTranslated(dict, "LABEL_NO")}
        </Button>,
        <Button key="ok" type="primary" onClick={handleAdvanced} className="sip-modal-btn">
            {getTranslated(dict, "LABEL_YES")} 
        </Button>,
      ];
    const ok = [
        <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
            {getTranslated(dict, "LABEL_OK")}
        </Button>
    ];

return (<>
        { // RSI prefix
            configurationData?.Profile?.UI_DispatchConsole_Prefix?.RSI_Prefix &&
            <div className="profile-span">
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_RSI_PREFIX_DATA")}
                    </Divider>

                    <NameNumberListComponent  
                        namePattern={configurationData?.Profile?.UI_DispatchConsole_Prefix?.RSI_Prefix[0]?.CCDn_Name?.pattern} 
                        numberPattern={configurationData?.Profile?.UI_DispatchConsole_Prefix?.RSI_Prefix[0]?.Local_Number?.pattern}
                        nameNumber={nameNumber} 
                        setNameNumber={setNameNumber}
                        ACDprefix={workingSipTrunkConfig?.Profile?.UI_DispatchConsole_Prefix?.ACD_Prefix?.Local_Number} />
            </div>
        }

        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onPreviousPage}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_CREATE")}
                type="primary"
                onClick={createProfile}
                disabled={errorsOnPage !== 0} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_ADVANCED")}
                type="primary"
                onClick={switchToAdvanced}
                disabled={errorsOnPage !== 0} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType}
            onCancel={handleCancel}
        >
            {message}
        </CustomDialog>
    </>);
}

export default RSIConfig;